
import React, { useState } from 'react';
import { NavLink , Link, useLocation } from 'react-router-dom';
import './Navigation.css';

const Navigation = ({ user, logout }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;
//  console.debug("the path in location: " + location.pathname);

  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <span className="logo-icon">🔮</span>
          <span className="logo-text">Mellodai</span>
        </Link>

        {/* Desktop Menu */}
        <div className="nav-menu desktop-menu">
          <Link 
            to="/app" //instead of older main root "/" before implementing the static pages.
            className={`nav-link ${isActive('/app') ? 'active' : ''}`}
          >
            <span className="nav-icon">🌟</span>
            <span>Predictions</span>
          </Link>
          <Link 
            to="/personas" 
            className={`nav-link ${isActive('/personas') ? 'active' : ''}`}
          >
            <span className="nav-icon">👥</span>
            <span>Personas</span>
          </Link>
          <Link 
            to="/add-event" 
            className={`nav-link ${isActive('/add-event') ? 'active' : ''}`}
          >
            <span className="nav-icon">➕</span>
            <span>Add Event</span>
          </Link>
          <Link 
            to="/settings" 
            className={`nav-link ${isActive('/settings') ? 'active' : ''}`}
          >
            <span className="nav-icon">⚙️</span>
            <span>Settings</span>
          </Link>
          
          <NavLink to="/upgrade" className="nav-link">
            <span className="nav-icon">💎</span>
            Upgrade
          </NavLink>
        </div>

        {/* User Menu */}
        <div className="nav-user">
          <div className="user-info">
            <div className="user-avatar">
              {user.email.charAt(0).toUpperCase()}
            </div>
            <div className="user-details">
              <span className="user-email">{user.email}</span>
              <div className="user-details-options">
              <span className={`user-tier tier-${user.tier}`}>
                {user.tier.toUpperCase()}
              </span><button className="logout-btn" onClick={logout}>
            Logout🚪
          </button></div>
            </div>
          </div>
          
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="mobile-menu">
          <Link 
            to="/" 
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            <span className="nav-icon">🌟</span>
            <span>Predictions</span>
          </Link>
          <Link 
            to="/personas" 
            className={`nav-link ${isActive('/personas') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            <span className="nav-icon">👥</span>
            <span>Personas</span>
          </Link>
          <Link 
            to="/add-event" 
            className={`nav-link ${isActive('/add-event') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            <span className="nav-icon">➕</span>
            <span>Add Event</span>
          </Link>
          <Link 
            to="/settings" 
            className={`nav-link ${isActive('/settings') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            <span className="nav-icon">⚙️</span>
            <span>Settings</span>
          </Link>
          <NavLink to="/upgrade" className="nav-link">
            <span className="nav-icon">💎</span>
            Upgrade
          </NavLink>
          <div className="mobile-user-info">
            <div className="user-email">{user.email}</div>
            <span className={`user-tier tier-${user.tier}`}>
              {user.tier.toUpperCase()}
            </span>
          </div>
          <button 
            className="logout-btn mobile"
            onClick={() => {
              logout();
              setIsMenuOpen(false);
            }}
          >
            🚪 Logout
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navigation;